import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import * as ja from 'date-fns/locale/ja';

@Pipe({
  name: 'entryDate'
})
export class EntryDatePipe implements PipeTransform {

  transform(date: string): string {
    return format(date, 'YYYY年MMMDo H:m', { locale: ja });
  }

}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/pipe/entry-date.pipe.ts